import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
import StaffIcon from "../../Icons/StaffIcon";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const LeaveApplicationListComponent = loadable(
  () => import("../../components/Leave/LeaveApplicationList")
);

const LeaveApplicationList = () => {
  const { data: profile, isLoading } = useGetHook({
    queryKey: ["user-profile"],
    url: `${APIS.USER}me/`,
    params: {},
  });

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StaffIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          leave Application
        </span>
      </div>
      <LeaveApplicationListComponent profile={profile} />
    </>
  );
};

export default LeaveApplicationList;
